module.exports = __webpack_public_path__ + "public/images/blob-right.34ec729caee6b61a222e68d4881e7c0a.png";